import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../../Resolve';
import * as Roles from '../../../common/Roles';

const states: Ng1StateDeclaration[] = [
    {
        name: 'applications.issues',
        url: '/issues',
        component: 'wtApplicationsIssues',
        resolve: {
            auth: Resolve.authResolve,
            roles: Resolve.rolesResolve([Roles.superAdministrator, Roles.administrator, Roles.master, Roles.engineer])
        },
        data: {
            visible: false,
            sortingOrder: 300,
            icon: 'fa-medkit',
            displayName: 'Applications issues',
            editRoles: [Roles.administrator, Roles.engineer],
            editButtonVisibility: () => false
        }
    }];

export default states;